import { SyncMethod } from './FamilyMember';

export const initialSync: SyncMethod = async replicationState => {
  await replicationState.start();
  await replicationState.awaitInitialReplication();
};
